import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { MutationConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { GeneralASError } from 'src/registry/types/axios';
import { CustomerPaymentMethod } from 'src/features/paymentMethods/utils/types';
import { CustomerPaymentMethodFormSchemaValues } from 'src/features/paymentMethods/utils/formSchema';

const RESOURCE = '/customers/customer-payment-method/:customerPaymentMethodId/';

type MutationFnType = typeof mutationFn;

interface DTO extends CustomerPaymentMethodFormSchemaValues {
    customerPaymentMethodId: string;
}
const mutationFn = ({ customerPaymentMethodId, ...data }: DTO): Promise<CustomerPaymentMethod> => {
    return axios.put(formatResourcePath(RESOURCE, { customerPaymentMethodId }), data);
};

const useMutationHook = (options: MutationConfig<MutationFnType, GeneralASError> = {}) =>
    useMutation({
        mutationFn,
        ...options,
    });

export { useMutationHook as useUpdateCustomerPaymentMethod };
